import { render, staticRenderFns } from "./BranchCustomerGroups.vue?vue&type=template&id=73ed6020&"
import script from "./BranchCustomerGroups.vue?vue&type=script&lang=ts&"
export * from "./BranchCustomerGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports